"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const SongwriterSummaryCard = ({ id, name, totalWorks }) => (react_1.default.createElement("div", { className: 'rightsholder-summary-card-wrapper' },
    react_1.default.createElement("div", { className: 'name-block' },
        react_1.default.createElement("h4", { title: name }, name)),
    react_1.default.createElement("div", { className: 'info-line' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h1", { className: 'blue-text' }, totalWorks.toLocaleString()),
            react_1.default.createElement("p", { className: 'small' }, "Total Works"))),
    react_1.default.createElement(Button_1.Button, { typeLink: true, linkTo: navigation_1.default.songwriter.catalog.root(id), mainColor: true, type: 'primary', icon: common_1.ICONS.arrow_forward }, "View My Catalog")));
exports.default = SongwriterSummaryCard;
